export default __webpack_public_path__ + "static/strategy-76df20dda330fc713fc44d4222d24da0.jpg";